// src/services/authService.js - Correction de l'import jwt-decode
import api from './api';
import { jwtDecode } from "jwt-decode";

const authService = {
  // Connexion utilisateur
  login: async (credentials) => {
    const response = await api.post('auth/login', credentials);
    if (response.data.token) {
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data));
    }
    return response.data;
  },
  
  // Déconnexion utilisateur
  logout: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  },
  
  // Récupérer l'utilisateur actuel depuis le localStorage
  getCurrentUser: () => {
    const userStr = localStorage.getItem('user');
    if (!userStr) return null;
    
    try {
      return JSON.parse(userStr);
    } catch (error) {
      localStorage.removeItem('user');
      return null;
    }
  },
  
  // Vérifier si l'utilisateur est authentifié
  isAuthenticated: () => {
    const token = localStorage.getItem('token');
    if (!token) return false;
    
    try {
      const decodedToken = jwtDecode(token);
      const currentTime = Date.now() / 1000;
      
      // Vérifier si le token n'est pas expiré
      return decodedToken.exp > currentTime;
    } catch (error) {
      return false;
    }
  },
  
  // Mettre à jour le mot de passe
  updatePassword: async (data) => {
    const response = await api.put('/auth/password', data);
    return response.data;
  },
  
  // Obtenir le profil utilisateur
  getUserProfile: async () => {
    const response = await api.get('/auth/profile');
    return response.data;
  },
};

export default authService;